import React, { useContext, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import GridItem from './GridItem';
import { TranslationContext, SettingsContext } from './Context';

const MoreInfoModal = props => {
    const translations = useContext(TranslationContext);
    const settings = useContext(SettingsContext);

    return (
        <Modal className="variantPickerComponent-modal" show={props.showModal} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title className="u-textBold28 text-center">{translations["VariantPicker.ModalTitle"]}</Modal.Title>   
            </Modal.Header>
            <div className="u-textRegular18 u-grayBackground text-center u-padding30">
                You added: {settings.skudata.skuNumber} to the cart! <a href={settings.cartUrl}>View cart</a>
            </div>
            <Modal.Body>
                <div className="row text-center">
                    <div className="col-md-8 col-md-push-2">
                        <p className="u-textRegular18 u-mbottom30">{translations["VariantPicker.ModalExplanation"]}</p>
                        <p><button className="btn btn-primary" onClick={props.handleClose}>{translations["VariantPicker.ModalButton"]}</button></p>
                    </div>
                </div>

                <div className="row u-mtop50">
                    <div className="col-xs-12">
                        <div className="variantPickerComponent-products">
                            {
                                Object.keys(settings.skudata.installationAccessories).map(x => (
                                    <GridItem data={settings.skudata.installationAccessories[x]} addToCart={props.addToCart} />
                                ))
                            }
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MoreInfoModal;